import { useEffect, useState } from 'react';
import axios from 'axios';

export const useGoogleReviews = () => {
  const [reviews, setReviews] = useState([]);

  useEffect(() => {
    const fetchReviews = async () => {
      const response = await axios.get('/reviews.json');
      setReviews(response.data);
    };
    fetchReviews();
  }, []);

  return reviews;
};
